import React from "react";

export const SkinPass = () => {
  return (
    <main className="mx-auto my-0">
      {/* Desktop Layout */}
<div className="hidden lg:flex justify-center relative h-[1109.68px]">
  <div className="w-[1262.69px] relative h-full">
    <div className="flex flex-col w-full h-[1109.68px] items-start relative">
      <img
        className="w-full h-[713.57px]"
        alt="Skin passport hero image showing diverse faces"
        src="/assets/images/backgrounds/skin_pass_bg.png"
      />

      <img
        className="self-stretch w-full aspect-[3.19]"
        alt="Half face and half cosmetics textures background"
        src="/assets/images/backgrounds/skin_pass_bg_2.png"
      />
    </div>

    <section className="absolute w-[627.77px] h-[225.94px] top-[790.79px] left-[3.6%]">
      <div className="relative w-[623.81px] h-[225.94px] bg-[#a89b8d] rounded-[17.16px] shadow-[0px_2.86px_2.86px_2.86px_#00000040]">
        <div
          style={{
            position: "absolute",
            width: "110px", // 100px * 1.1
            height: "110px",
            top: "25%",
            left: "75%",
            backgroundImage:
              "url('/assets/images/backgrounds/cosmelytix_mini_logo_white.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            zIndex: 1000,
          }}
        />

        <h1 className="absolute top-[9.1%] left-[6%] font-sans font-semibold text-white text-[24.31px] tracking-[0] leading-[normal]">
          Skin Passport
        </h1>

        <p className="absolute w-[401.83px] top-[66px] left-[6%] font-sans font-normal text-white text-[16px] tracking-[0] leading-[normal]">
          Skin Passport is your personalized skincare profile, built to address
          everything from hydration and brightness to anti-aging concerns like
          forehead lines, crow’s feet, and sagging jawlines. Alongside
          anti-aging solutions, you’ll get recommendations for overall skin
          health, targeted improvements, and beauty products tailored to your
          individual profile.
        </p>
      </div>
    </section>
  </div>
</div>

{/* Mobile Layout (Simplified) */}
<div className="block lg:hidden w-full h-full flex flex-col items-center justify-center px-0">
  {/* First background image */}
  <img
    className="w-full h-auto"
    alt="Skin passport hero image showing diverse faces"
    src="/assets/images/backgrounds/skin_pass_bg.png"
  />

  {/* Second background image with section over it */}
  <div className="relative w-full">
    <img
      className="w-full h-auto"
      style={{ aspectRatio: "3.19 / 3.7" }}
      alt="Half face and half cosmetics textures background"
      src="/assets/images/backgrounds/skin_pass_bg_2_mobile_3.png"
    />

    <section className="absolute inset-0 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-[90%] bg-[#a89b8d] rounded-[12px] shadow-[0px_2px_2px_2px_#00000040] p-4 text-white text-center">
        <div className="flex justify-center items-center mb-4">
          <a
            href="https://cosmelytix.com/skin-passport/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center"
          >
            <img
              className="w-10 h-10 mr-4"
              alt="Skin passport icon"
              src="/assets/images/backgrounds/cosmelytix_mini_logo_white.png"
            />
            <h1 className="font-semibold text-[17px]">Skin Passport</h1>
          </a>
        </div>
        <p className="text-[17px]">
          Skin Passport is your personalized skincare profile, built to address everything from hydration and brightness to anti-aging concerns like forehead lines, crow’s feet, and sagging jawlines. 
          <br/> 
          <br/>
          Alongside anti-aging solutions, you’ll get recommendations for overall skin health, targeted improvements, and beauty products tailored to your individual profile.
        </p>
        <br/>
      </div>
    </section>
  </div>
</div>

    </main>
  );
};
